// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".note-dialog .small-sub-title {\n  color: #366baf !important;\n  font-weight: 600;\n  margin-top: 5px;\n}", ""]);
// Exports
module.exports = exports;
